// extracted by mini-css-extract-plugin
module.exports = {"WrapperAnaloguesProduct":"AnaloguesProduct_WrapperAnaloguesProduct__4BjBi","LinkSize":"AnaloguesProduct_LinkSize__xPTP0","Title":"AnaloguesProduct_Title__9r7rw"};